export interface RequiredPromptAddition {
  id: string;
  label: string;
  body: string;
  reason: string;
}

export function candidateCountConflict(body: string): string | null {
  const match = body.match(
    /\b(?:return|generate|emit|produce|provide)\b[^.\n]{0,100}\b(?:exactly\s+)?(1|one|3|three)\s+(?:candidate\s+)?(?:suggestion|suggestions|candidate|candidates)\b/i,
  );
  if (!match) return null;
  const count = /^(?:1|one)$/i.test(match[1]) ? 1 : 3;
  return `This system prompt hardcodes ${count} candidate${count === 1 ? "" : "s"}, but runtime candidate count changes with judge mode.`;
}

export function missingRequiredPromptAdditions(
  body: string,
  additions: readonly RequiredPromptAddition[],
): RequiredPromptAddition[] {
  const normalizedBody = normalizeForContainment(body);
  return additions.filter(
    (addition) => !normalizedBody.includes(normalizeForContainment(addition.body)),
  );
}

function normalizeForContainment(value: string): string {
  return value.replace(/\s+/gu, " ").trim();
}
